import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Table, TableBody } from '@digdir/designsystemet-react';

import { CalculationParameterCategory } from '../../../../../types/calculationParameters';

import { ExpertValue, Title } from './components';
import { hiddenFields } from './utils';
import {
  BorderRightHeaderCell,
  BorderRightTableCell,
  CalculatedValueTableCell,
  ExpertValueTableCell,
  HeaderTableRow,
  StyledTableRow
} from './styledComponents';

interface LargeScreenItemProps {
  category: CalculationParameterCategory;
}

export const LargeScreenItem: FC<LargeScreenItemProps> = ({ category }) => {
  const { t } = useTranslation();

  return (
    <Table border>
      <Table.Head>
        <HeaderTableRow>
          <BorderRightHeaderCell>{t('register.parameters.name')}</BorderRightHeaderCell>
          <BorderRightHeaderCell>{t('register.parameters.calculated')}</BorderRightHeaderCell>
          <Table.HeaderCell>{t('register.parameters.new')}</Table.HeaderCell>
        </HeaderTableRow>
      </Table.Head>

      <TableBody>
        {Object.entries(category).map(([parameterKey, { calculatedValue, unit }]) => {
          return (
            <StyledTableRow data-color="main" $isHidden={hiddenFields.includes(parameterKey)} key={parameterKey}>
              <BorderRightTableCell>
                <Title parameterKey={parameterKey} />
              </BorderRightTableCell>
              <CalculatedValueTableCell>{Number(calculatedValue.toFixed(3))}</CalculatedValueTableCell>
              <ExpertValueTableCell>
                <ExpertValue unit={unit} parameterKey={parameterKey} />
              </ExpertValueTableCell>
            </StyledTableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};
